export default __webpack_public_path__ + "static/media/-pic1.37a4dd5f.png";